import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DokumentyKlientaService } from '../../@core/http/dokumenty-klienta.service';
import { KomunikatyTabeli, KomunikatyTabeliService } from '../../@core/utils/komunikaty-tabeli.service';
import { DokumentKlienta } from '../../shared/models/dokument-klienta.model';
import { ZakresDat } from '../../shared/models/zakres-dat.model';

@Component({
  selector: 'ngx-dokumenty-klienta',
  templateUrl: './dokumenty-klienta.component.html',
  styleUrls: ['./dokumenty-klienta.component.scss'],
})
export class DokumentyKlientaComponent implements OnInit, OnDestroy {

  dane: DokumentKlienta[];
  temp = [];
  eksportKolumny = [];
  eksportPdfKolumnyStyle;
  zakresDat: ZakresDat;
  wyswietlanieFiltrow = false;

  private apiSubscription: Subscription;

  komunikatyTabeli: KomunikatyTabeli;

  constructor(
    private readonly dokumentyKlientaService: DokumentyKlientaService,
    private readonly komunikatyTabeliService: KomunikatyTabeliService,
    private readonly translate: TranslateService,
  ) { }

  ngOnInit() {
    this.odswiezKomunikatyTabeli();
    this.translate.onLangChange.subscribe(() => this.odswiezKomunikatyTabeli());
  }

  ngOnDestroy(): void {
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
  }

  private odswiezKomunikatyTabeli() {
    this.komunikatyTabeli = this.komunikatyTabeliService.get();
  }

  onChangeZmianaZakresu(zakresDat: ZakresDat) {
    this.zakresDat = zakresDat;
    this.apiSubscription = this.dokumentyKlientaService.getDokumenty(zakresDat)
      .subscribe(response => {
        this.temp = [...response];
        this.dane = response;
      });
  }

}
